import { Link as StyledLink } from '@atlassian/amkt-common';
import { AppMarketingLabel } from '@atlassian/mpac-types';
import React from 'react';
import { Link } from 'react-router-dom';
export const makeCategoryLozenges = _ref => {
  let {
    categories
  } = _ref;
  if (categories.some(category => category.name === 'Mobile')) {
    return [{
      label: 'Supports Mobile',
      tooltipContent: 'This app is optimized for mobile experience.'
    }];
  }
  return [];
};
export const makeProductCompatibilityLozenges = _ref2 => {
  let {
    marketingLabels,
    showNewJiraSoftwareLabelFlag
  } = _ref2;
  const lozenges = [];
  if (marketingLabels.includes(AppMarketingLabel.CompatibleWithJSM)) {
    const flavor = 'Jira Service Management';
    lozenges.push({
      label: flavor,
      tooltipContent: /*#__PURE__*/React.createElement("p", null, "This app is compatible with ", flavor, ".")
    });
  }
  if (marketingLabels.includes(AppMarketingLabel.CompatibleWithJSW)) {
    const flavor = showNewJiraSoftwareLabelFlag ? 'Jira' : 'Jira Software';
    lozenges.push({
      label: flavor,
      tooltipContent: /*#__PURE__*/React.createElement("p", null, "This app is compatible with ", flavor, ".")
    });
  }
  return lozenges;
};
export const makeSupportInfoLozenges = _ref3 => {
  let {
    isSupported,
    partnerName,
    supportLink,
    isServerAppEos
  } = _ref3;
  if (isServerAppEos) return [];else if (isSupported) {
    if (!partnerName) return [];
    return [{
      label: 'Supported',
      tooltipContent: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, partnerName, " supports this app."), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
        to: supportLink
      }, "Get support")))
    }];
  } else return [{
    label: 'Unsupported',
    tooltipContent: /*#__PURE__*/React.createElement("p", null, "This app isn't formally supported")
  }];
};
export const makeCloudMigrationLozenge = _ref4 => {
  let {
    cloudMigration = {},
    onMigrationLozengeClick,
    showCloudMigrationLozenge
  } = _ref4;
  if (!showCloudMigrationLozenge) return [];
  const {
    featureDifferenceDocumentation,
    migrationDocumentation
  } = cloudMigration || {};
  const hasDocumentation = featureDifferenceDocumentation || migrationDocumentation;
  if (!hasDocumentation) {
    return [];
  }
  return [{
    label: 'Cloud Migration Assistance',
    appearance: 'inprogress',
    tooltipContent: /*#__PURE__*/React.createElement("p", null, "This partner provides links to support your cloud migration journey. Scroll down to the", ' ', /*#__PURE__*/React.createElement(StyledLink, {
      onClick: onMigrationLozengeClick
    }, "Resources"), " section for more details.")
  }];
};
export const makeHeaderLozenges = _ref5 => {
  let {
    isSupported,
    partnerName,
    supportLink,
    marketingLabels,
    categories,
    cloudMigration,
    onMigrationLozengeClick,
    showCloudMigrationLozenge,
    isServerAppEos,
    showNewJiraSoftwareLabelFlag
  } = _ref5;
  return [...makeSupportInfoLozenges({
    isSupported,
    partnerName,
    supportLink,
    isServerAppEos
  }), ...makeProductCompatibilityLozenges({
    marketingLabels,
    showNewJiraSoftwareLabelFlag
  }), ...makeCategoryLozenges({
    categories
  }), ...makeCloudMigrationLozenge({
    cloudMigration,
    onMigrationLozengeClick,
    showCloudMigrationLozenge
  })].filter(Boolean);
};